import { render } from "./LbrxDisplaySecondTheme.vue?vue&type=template&id=dbb6445a&scoped=true"
import script from "./LbrxDisplaySecondTheme.vue?vue&type=script&lang=js"
export * from "./LbrxDisplaySecondTheme.vue?vue&type=script&lang=js"

import "./LbrxDisplaySecondTheme.vue?vue&type=style&index=0&id=dbb6445a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbb6445a"]])

export default __exports__